import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg" {...props}><circle stroke="#FFF" strokeWidth="5" fill="#FFF" transform="matrix(1 0 0 -1 0 39)" cx="19.5" cy="19.5" r="17" fillRule="evenodd" /></svg>);